var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSalesPipelineSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#36F",
    fillRule: "nonzero",
    stroke: "#36F",
    strokeWidth: 1.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.087 1c.06 0 .115.045.147.12l1.728 3.915c.04.09.04.206 0 .296L8.234 9.246c-.032.075-.088.12-.147.12h-6.91c-.141 0-.225-.238-.147-.416l1.662-3.767L1.03 1.415C.952 1.238 1.036 1 1.177 1h6.91zm-.183.426H1.5L3.08 5.01l.076.172-.076.172L1.5 8.94h6.404l1.658-3.757-1.658-3.757z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.062 1c.06 0 .114.045.147.12l1.728 3.915c.04.09.04.206 0 .296l-1.728 3.916c-.033.074-.088.119-.147.119h-6.91c-.141 0-.225-.238-.147-.416l1.662-3.767-1.662-3.768C7.927 1.238 8.011 1 8.152 1h6.91zm-.183.426H8.475l1.581 3.585.076.172-.076.172L8.475 8.94h6.404l1.658-3.757-1.658-3.757z"
  }))));
}

export default SvgSalesPipelineSmall;